<template>
  <b-card>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loading"
    >
      <b-row>
        <b-col md="4">
          <label for="code-filter">Search by code</label>
          <b-form-input
            id="code-filter"
            v-model="queryParams.code"
            placeholder="Code"
          />
        </b-col>
        <b-col md="4">
          <label for="date1">Effective Date</label>
          <b-form-datepicker
            id="date1"
            v-model="effectiveDate"
          />
        </b-col>
        <b-col md="4">
          <label for="date2">Expiry Date</label>
          <b-form-datepicker
            id="date2"
            v-model="expiryDate"
          />
        </b-col>
        <b-col
          md="4"
          class="d-flex align-items-center my-1"
        >
          <b-button
            class="mr-2"
            variant="primary"
            @click="fetchPromoCodes"
          >
            Search
          </b-button>
          <b-button
            variant="danger"
            @click="resetFilters"
          >
            Clear
          </b-button>
        </b-col>
        <b-col
          md="8"
          class="d-flex justify-content-end align-items-center my-1"
        >
          <b-button
            variant="primary"
            @click="$router.push('/promo-codes/new')"
          >
            <span>Add Promo Code</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        :fields="tableColumns"
        :items="promoCodesList"
        striped
        hover
        responsive
        thead-class="text-nowrap text-center"
        tbody-class="text-nowrap text-center"
        show-empty
        empty-text="No matching Promo Codes found"
        @row-clicked="rowClicked"
      >
        <template #cell(active)="data">
          <b-badge
            pill
            :variant="`light-${data.item.active ? 'success' : 'danger'}`"
            class="text-capitalize"
          >
            {{ data.item.active ? 'Active' : 'Inactive' }}
          </b-badge>
        </template>
      </b-table>
      <base-pagination
        v-model="queryParams.page"
        :total="total"
        @new-per-page="queryParams.per_page = $event"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BOverlay, BBadge, BButton, BRow, BCol, BFormInput, BFormDatepicker,
} from 'bootstrap-vue'
import usePromoCodesList from '../hooks/usePromoCodesList'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import promoCodesStore from '../store'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BCard,
    BTable,
    BOverlay,
    BFormInput,
    BasePagination,
    BFormDatepicker,
    BBadge,
    BRow,
    BCol,
    BButton,
  },
  setup(_, ctx) {
    useRegisterStoreModule('promoCodes', promoCodesStore)
    const rowClicked = event => {
      if (ctx.root.$can('write', 'promo-codes')) {
        ctx.root.$router.push(`/promo-codes/edit/${event.id}`)
      }
    }
    return {
      rowClicked,
      ...usePromoCodesList(ctx),
    }
  },
}
</script>

<style>

</style>
